import { all, fork } from "redux-saga/effects";

import homeSagas from "../home/sagas";
import prizeSagas from "../prize/sagas";
import gameSagas from "../game/sagas";
import addressSagas from "../address/sagas";

export default function* rootSaga() {
  yield all([
    fork(homeSagas),
    fork(prizeSagas),
    fork(gameSagas),
    fork(addressSagas),
  ]);
}
